import _ from 'lodash'
import { FormRootState } from '../../redux/formStore'
import { FormThunk } from '../../redux/formStore'
import { Comment, commentIsEditable } from "@fusion-advantage/formlib"
import { selectFormDisplayIdentity } from '../relay/AppFormRelay'
import { selectExport } from '../../redux/selectForm'

const selectMetaForComment = (state: FormRootState) => {
	const user = selectFormDisplayIdentity(state)
	const encounterAppLastStatusDT = selectExport(state)?.Form.Encounter.EncounterAppLastStatusDT
	if(!user || !encounterAppLastStatusDT) {
		return false
	}
	return {
		user,
		encounterAppLastStatusDT,
	}
}

export const addComment = (comments: Comment[], message: string): FormThunk<Comment[]|false> => (dispatch, getState) => {
	const meta = selectMetaForComment(getState())
	if(!meta) {
		return false
	}
	return [
		...comments,
		{
			message,
			authorName: meta.user.fullName,
			authorUpn: meta.user.upn,
			timestamp: Date.now(),
			encounterAppLastStatusDT: meta.encounterAppLastStatusDT,
		}
	]
}

export const updateComment = (comments: Comment[], idx: number, message: string): FormThunk<Comment[]|false> => (dispatch, getState) => {
	const meta = selectMetaForComment(getState())
	if(!meta) {
		return false
	}
	if(!commentIsEditable(comments[idx], meta.encounterAppLastStatusDT)) {
		return false
	}
	comments = _.cloneDeep(comments)
	comments[idx].message = message
	comments[idx].timestamp = Date.now()
	return comments
}